import axios from '@/libs/api.request'

/**
 * 保存整个项目计划（固结、帷幕、回填）
 */
export const saveProjectPlan = (plan_gt1, plan_gt2, plan_gt3) => {
    const data ={
        "plan_gt1": plan_gt1,
        "plan_gt2": plan_gt2,
        "plan_gt3": plan_gt3
    }
    return axios.request({
        url: '/api/admin/projectdivision/saveProjectPlan',
        data,
        method: 'post'
    })
}